import { render, staticRenderFns } from "./Postcode.vue?vue&type=template&id=68b192b2&scoped=true"
import script from "./Postcode.vue?vue&type=script&lang=js"
export * from "./Postcode.vue?vue&type=script&lang=js"
import style0 from "./Postcode.vue?vue&type=style&index=0&id=68b192b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b192b2",
  null
  
)

export default component.exports